module.exports = __webpack_public_path__ + "images/emoji/tanabata_tree.de40e8c72404da0e6d75.png";